import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './terms.css';

function Terms({ onClose }) {
  const navigate = useNavigate();
  const [selectedVersion, setSelectedVersion] = useState('v1.0-2025-07-31');

  const handleBack = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  const termsVersions = [
    { id: 'v1.0-2025-07-31', version: 'v 1.0', status: 'new', date: '2025.07.31' }
  ];

  const getVersionLabel = (version) => {
    const selected = termsVersions.find(v => v.id === version);
    if (!selected) return '';
    
    const statusText = selected.status === 'new' ? 'new' : 
                      selected.status === 'previous' ? 'previous' : 'initial';
    
    return `${selected.version} - ${statusText} - ${selected.date}`;
  };

  return (
    <>
      <Helmet>
        <title>이용약관 - 주식회사 가까운물류</title>
      </Helmet>
      {/* 오버레이 */}
      <div className="gakkaun-terms-modal-overlay" onClick={handleBack}></div>
      
      {/* 팝업 */}
      <div className="gakkaun-terms-modal">
        {/* 헤더 */}
        <header className="gakkaun-terms-header">
          <button onClick={handleBack} className="gakkaun-back-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="gakkaun-terms-title">이용약관</h1>
        </header>

        {/* 메인 콘텐츠 */}
        <main className="gakkaun-terms-main">
        <div className="gakkaun-terms-container">
          <div className="gakkaun-terms-content">
            <div className="gakkaun-version-selector">
              <select 
                value={selectedVersion} 
                onChange={(e) => setSelectedVersion(e.target.value)}
                className="gakkaun-version-select"
              >
                {termsVersions.map(version => (
                  <option key={version.id} value={version.id}>
                    {getVersionLabel(version.id)}
                  </option>
                ))}
              </select>
            </div>
            <div className="gakkaun-terms-intro">
              <p>
                본 약관은 "가까운 물류"(이하 "회사")가 제공하는 화물 유통 및 거래 연결 서비스(이하 "서비스")의 이용조건과 절차, 
                회사와 이용자 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
              </p>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제1조 (목적)</h2>
              <p className="gakkaun-section-content">
                본 약관은 "가까운 물류"(이하 "회사")가 제공하는 화물 유통 및 거래 연결 서비스(이하 "서비스")의 이용조건과 절차, 
                회사와 이용자 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
              </p>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제2조 (서비스 범위)</h2>
              <div className="gakkaun-section-content">
                <p>① 회사는 화물 운송 및 유통 거래의 매칭, 관련 정보 제공 및 부가 서비스를 제공합니다.</p>
                <p>② 회사는 서비스 품질 향상이나 운영상 필요에 따라 서비스 내용을 변경할 수 있으며, 변경 시 사전 공지합니다.</p>
              </div>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제3조 (이용자의 의무)</h2>
              <div className="gakkaun-section-content">
                <p>① 이용자는 서비스 이용 시 법령, 본 약관, 공지사항을 준수해야 하며 서비스 운영을 방해하는 행위를 해서는 안 됩니다.</p>
                <p>② 허위 정보 제공, 타인의 권리를 침해하거나 부정한 목적으로 서비스를 이용하는 행위를 금지합니다.</p>
              </div>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제4조 (회사의 의무)</h2>
              <div className="gakkaun-section-content">
                <p>① 회사는 안정적인 서비스 제공을 위해 최선을 다하며, 장애 발생 시 신속히 복구하도록 노력합니다.</p>
                <p>② 회사는 개인정보보호법 등 관련 법령을 준수하며, 이용자의 개인정보를 안전하게 보호합니다.</p>
              </div>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제5조 (서비스 중단)</h2>
              <div className="gakkaun-section-content">
                <p>① 회사는 시스템 점검, 업그레이드, 또는 불가항력적 사유가 발생한 경우 일시적으로 서비스를 중단할 수 있습니다.</p>
                <p>② 긴급한 사유로 사전 공지가 불가한 경우 사후 공지할 수 있습니다.</p>
              </div>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제6조 (거래에 대한 책임)</h2>
              <p className="gakkaun-section-content">
                회사는 화물 운송 계약이나 거래 당사자 간에 발생하는 문제(계약 불이행, 사고, 손해 등)에 대해 직접적인 책임을 지지 않습니다.
              </p>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제7조 (손해배상)</h2>
              <div className="gakkaun-section-content">
                <p>① 회사는 고의 또는 중대한 과실이 없는 한 서비스 이용과 관련해 발생하는 손해에 대해 책임지지 않습니다.</p>
                <p>② 이용자가 약관을 위반하거나 불법 행위로 인해 회사에 손해가 발생한 경우, 이용자는 이를 배상해야 합니다.</p>
              </div>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제8조 (면책)</h2>
              <p className="gakkaun-section-content">
                회사는 천재지변, 통신 장애, 서버 오류 등 불가항력으로 인한 서비스 중단이나 데이터 손실에 대해 책임을 지지 않습니다.
              </p>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">제9조 (약관 변경)</h2>
              <p className="gakkaun-section-content">
                회사는 필요한 경우 약관을 개정할 수 있으며, 변경 시 최소 7일 전에 서비스 화면 또는 기타 방법으로 공지합니다.
              </p>
            </div>

            <div className="gakkaun-terms-section">
              <h2 className="gakkaun-section-title">부칙</h2>
              <p className="gakkaun-section-content">
                본 약관은 2025년 7월 31일부터 시행합니다.
              </p>
            </div>
          </div>
        </div>
      </main>
      </div>
    </>
  );
}

export default Terms;
